import { ticketStatusLabel } from '@/shared/config';
import type { Notification } from '@/entities/notification';

export function formatNotificationTitle(n: Notification): string {
  let title = n.title ?? 'Изменение в обращении';
  if (n.eventType === 'status_changed' && n.payload) {
    for (const key of ['oldStatus', 'newStatus'] as const) {
      const raw = n.payload[key];
      if (typeof raw === 'string' && raw) {
        title = title.split(raw).join(ticketStatusLabel(raw));
      }
    }
  }
  return title;
}

export function splitNotificationTitle(n: Notification): { event: string; subject: string | null } {
  const title = formatNotificationTitle(n);
  const at = title.indexOf(': ');
  if (at < 0) return { event: title, subject: null };
  let event = title.slice(0, at);
  let subject = title.slice(at + 2);
  const dash = subject.indexOf(' — ');
  if (n.eventType === 'status_changed' && dash >= 0) {
    event = `${event}: ${subject.slice(dash + 3)}`;
    subject = subject.slice(0, dash);
  }
  return { event, subject: subject ? subject[0].toUpperCase() + subject.slice(1) : null };
}
